var blockBundles;

try {
    blockBundles = {
		jsqy_kol: {
			content:{
				header: {
					 html: require("../../jsqy_kol/header/header.html.twig"), 
					 scss: require("../../jsqy_kol/header/header.scss"), 
					 js: require("../../jsqy_kol/header/header.js"), 
					 dir: "jsqy_kol/header/header"
				},
				char: {
					html: require("../../jsqy_kol/char/char.html.twig"), 
					scss: require("../../jsqy_kol/char/char.scss"), 
					js: require("../../jsqy_kol/char/char.js"), 
					dir: "jsqy_kol/char/char"
			   },
				
				footer: {
					 html: require("../../jsqy_kol/footer/footer.html.twig"), 
					 scss: require("../../jsqy_kol/footer/footer.scss"), 
					 js: require("../../jsqy_kol/footer/footer.js"), 
					 dir: "jsqy_kol/footer/footer"
				}
			},
			float:{
				
			
			}
		},
		common: {
			required:{
				required_loading: {
					 html: require("../../common/required_loading/required_loading.html.twig"), 
					 scss: require("../../common/required_loading/required_loading.scss"), 
					 js: require("../../common/required_loading/required_loading.js"), 
					 dir: "common/required_loading/required_loading"
				}
			}
		}
    }
} catch(error) {
    console.log(error);
}

export default blockBundles;